import { useNavigate, useParams } from 'react-router-dom';
import { MissionRunner } from '../etch/MissionRunner';

/**
 * `/missions/run/:missionId` — route shell around the runner.
 *
 * The runner itself takes no router dependency so it can also be embedded in
 * an onboarding chapter (spec §9.4 "Mischung aus Inhalt, Fragen, Missionen und
 * Praxisaufgaben") without inheriting this route's navigation.
 *
 * `key={missionId}` forces a fresh runner per mission: the component owns an
 * attempt, and reusing its state across two missions would carry one mission's
 * answers into another's attempt.
 */
export function MissionRunnerView() {
  const { missionId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="etch-view">
      <div className="etch-column">
        <MissionRunner key={missionId} missionId={missionId} onExit={() => navigate('/missions')} />
      </div>
    </div>
  );
}

export default MissionRunnerView;
